import { unref, computed } from 'vue'
import { APP_PROMOTION_TYPE, DELIVERY_MODE } from '../consts/index.js'

export const usePageStates = () => {
  const path = window.location.href

  // 批量复制
  const isDuplicate = computed(() => path.includes('/duplicate/'))
  // 批量修改
  const isModify = computed(() => path.includes('/edit/'))
  // 单条修改
  const isUpdate = computed(() => path.includes('/plan-edit'))
  // 批量新建
  const isCreate = computed(() => path.includes('/create/'))
  // 腾讯广告3.0模板新建计划
  const isTemplate = computed(() => path.includes('/toutiao/template') || path.includes('/toutiaov3/template'))

  return {
    isDuplicate,
    isModify,
    isUpdate,
    isCreate,
    isTemplate
  }
}

export const useProjectParamStates = (projectForm) => {
  /**
   * @description: 是否预约下载
   */
  const isReservation = computed(() => unref(projectForm).app_promotion_type === APP_PROMOTION_TYPE.RESERVE)

  /**
   * @description: 手动投放
   */
  const isManual = computed(() => unref(projectForm)?.delivery_mode === DELIVERY_MODE.MANUAL)

  /**
   * @description: 自动投放
   */
  const isProcedural = computed(() => unref(projectForm)?.delivery_mode === DELIVERY_MODE.PROCEDURAL)

  return {
    isReservation,
    isManual,
    isProcedural
  }
}
